// extracted by mini-css-extract-plugin
export default {"svg":"UserPrefsButton_svg__cdFwT","div":"UserPrefsButton_div__rhfZI"};